module.exports = __webpack_public_path__ + "static/media/D2.ec42b772.png";